module.exports = new __parcel__URL__("discard.eef75f34.mp3").toString();